import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { UPDATE_BENEFIT_GROUP_ITEM, UPDATE_BENEFIT_GROUP_ITEM_SUCCESS, UPDATE_BENEFIT_GROUP_ITEM_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* UpdateBenefitGroupItems({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/benefit-configs`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: UPDATE_BENEFIT_GROUP_ITEM_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UPDATE_BENEFIT_GROUP_ITEM_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_BENEFIT_GROUP_ITEM_ERROR, payload: error });
  }
}

export function* watchUpdateBenefitGroupItems() {
  yield takeEvery(UPDATE_BENEFIT_GROUP_ITEM, UpdateBenefitGroupItems);
}

function* updateBenefitGroupItemsSaga() {
  yield all([fork(watchUpdateBenefitGroupItems)]);
}

export default updateBenefitGroupItemsSaga;
